export default "__VITE_ASSET__CSMaAdLh__"